import React, { Component, Suspense } from 'react'
import { useTranslation } from '../i18n/LanguageContext'
import { isStaleBuildError } from '../lib/staleBuild.js'
import './DeferredSection.css'

// Keep failures local to an optional section. Never reload automatically: the
// buyer may have an unsaved search, budget or plate input elsewhere in the app.
// A section left behind by a newer deployment is not a connection problem, so it
// says so and offers a reload the buyer chooses.
export class SectionBoundary extends Component {
  state = { failed: false, stale: false }
  static getDerivedStateFromError(error) { return { failed: true, stale: isStaleBuildError(error) } }
  render() {
    if (!this.state.failed) return this.props.children
    return this.state.stale && this.props.staleFallback ? this.props.staleFallback : this.props.fallback
  }
}

export default function DeferredSection({ children, onBack }) {
  const { t } = useTranslation()
  const failure = <main className="app-main"><section className="section-status section-load-error" role="alert">
    <h2>{t('This section could not be loaded')}</h2>
    <p>{t('Your saved data has not been changed. Check your connection, then reload the page after saving important inputs. Other tabs remain available.')}</p>
    <button type="button" onClick={onBack}>{t('Back to search')}</button>
  </section></main>
  const stale = <main className="app-main"><section className="section-status section-load-error" role="alert">
    <h2>{t('A newer version of AutoMargin is available')}</h2>
    <p>{t('This part of the app changed after you opened the page. Your saved data has not been changed. Reload when you are ready; unsaved input on this page will be lost.')}</p>
    <button type="button" onClick={() => window.location.reload()}>{t('Reload page')}</button>{' '}
    <button type="button" onClick={onBack}>{t('Back to search')}</button>
  </section></main>
  return <SectionBoundary fallback={failure} staleFallback={stale}>
    <Suspense fallback={<main className="app-main"><section className="section-status section-loading" role="status" aria-live="polite">
      <p>{t('Loading this section…')}</p>
      <button type="button" onClick={onBack}>{t('Back to search')}</button>
    </section></main>}>{children}</Suspense>
  </SectionBoundary>
}
